import { useMemo } from 'react'
import { addGtmPrefix } from '../core'
import { useAbTestPattern } from './useAbTestPattern'

interface UseAbTestGtmProps {
    abValue?: number
    currentPath?: string
    currentSearch?: string
}

interface GtmLabels {
    dataClickLabel: (originalLabel: string) => string
    dataViewLabel: (originalLabel: string) => string
}

// パターン判定は useAbTestPattern に一本化している（挙動は従来どおり）。
// 以前は同じcookieの読み書きをこちらにも複製していたが、DEV-3390で参加判定に
// targetQuery が入ったため、複製したままだと**こちらが対象外の流入にもcookieを書いてしまい**、
// cookieの存在を参加印にしている useAbTestPattern 側の判定を無効化する。
// なお同じコンポーネントがこのフックと useAbTestPattern を両方呼ぶ構成では、
// useAbTestPattern のインスタンスは依然2つになる（cookieを介して値は揃う）。
export const useAbTestGtm = ({
    abValue,
    currentPath = typeof window !== 'undefined'
        ? window.location.pathname
        : '/',
    currentSearch,
}: UseAbTestGtmProps = {}): GtmLabels => {
    const { pattern, isResolved } = useAbTestPattern({
        abValue,
        currentPath,
        currentSearch,
    })

    return useMemo(
        () => ({
            // 判定が確定するまでは素のラベルを返す（従来どおり）
            dataClickLabel: (originalLabel: string): string =>
                isResolved ? addGtmPrefix(originalLabel, currentPath, pattern) : originalLabel,

            dataViewLabel: (originalLabel: string): string =>
                isResolved ? addGtmPrefix(originalLabel, currentPath, pattern) : originalLabel,
        }),
        [isResolved, pattern, currentPath]
    )
}


